import React from 'react';
import DOMPurify from 'dompurify';

import { SuperEllipse } from '@alfalab/core-components/icon-view/super-ellipse';
import { SystemMessage } from '@alfalab/core-components/system-message';

interface Props {
    title: string;
    subTitle: string;
    children?: string | JSX.Element | JSX.Element[];
    icon?: string;
    caption?: string;
}

export const SystemMessageItem = ({ title, subTitle, children, icon, caption }: Props) => (
    <SystemMessage dataTestId='system-message'>
        {icon && (
            <SystemMessage.Graphic>
                <SuperEllipse size={80}>
                    <img src={icon} alt='icon' width={48} height={48} />
                </SuperEllipse>
            </SystemMessage.Graphic>
        )}

        <SystemMessage.Title>{title}</SystemMessage.Title>

        <SystemMessage.Subtitle>
            <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subTitle) }} />
        </SystemMessage.Subtitle>

        {caption && <SystemMessage.Caption>{caption}</SystemMessage.Caption>}

        {children && <SystemMessage.Controls direction='column'>{children}</SystemMessage.Controls>}
    </SystemMessage>
);
